<template>
    <div class="main main-padding new-data-details">
        <div class="top-area">
            <!--返回-->
            <div class="main-back">
                <div class="bank-back" v-on:click="gotoBack">
                    <img src="../../../assets/images/back.png" alt="暂无数据"/>
                    <p class="click-text">返回</p>
                </div>
            </div>
            <!--时间选择器-->
            <div class="time-select-picker">
                <div class="time-select">
                    <Row :gutter="10">
                        <date-select @updateDateTime="updateDateTime" ref="dateSelect"></date-select>
                    </Row>
                </div>
            </div>
        </div>
        <!--数据信息-->
        <card>
            <!--标题及搜索框-->
            <div class="details-card-header-area">
                <!--tab切换数据-->
                <div class="details-tab-data">
                    <span>教师布置作业详情</span>
                </div>
                <!--搜索框-->
                <div class="input-data">
                    <Input
                        v-model="keyWord"
                        placeholder="支持教师名称关键字搜索"
                        icon="ios-search"
                        clearable
                        @on-enter="handleSearch"
                    >
                        <Button
                            slot="append"
                            icon="ios-search"
                            class="search-input-button"
                            @click="handleSearch"
                            type="primary"
                        ></Button>
                    </Input>
                </div>
            </div>
            <div>
                <!--活跃大屏具体使用详情-->
                <div class="table-wrapper-data">
                    <Table :columns="columns" :data="assHomeworkTea"></Table>
                </div>
                <!--分页,大屏重复绑定情况下不显示-->
                <div class="laypage_main">
                    <Page
                        :total="total"
                        :current="page"
                        :page-size="limit"
                        @on-change="handleCurrentChange"
                        v-show="total && pageCount>1"
                        show-total
                    />
                </div>
            </div>
        </card>
    </div>
</template>
<script>
    import {findTeachersList} from "../../../service/api.js";
    import dateSelect from "../../../components/dateSelect.vue";

    export default {
        name: "ass-homework-tea",
        data () {
            return {
                schoolId: this.$route.query.schoolId, //学校ID
                schoolName: this.$route.query.schoolName, //学校ID
                selfStartDate: this.$route.query.parentalStartDate,//一级页面传来的开始时间
                selfEndDate: this.$route.query.parentalEndDate,//一级页面传来的结束时间
                parentalStartDate: this.$route.query.parentalStartDate,//记住页面传来的开始时间
                parentalEndDate: this.$route.query.parentalEndDate,//记住页面传来的结束时间
                curSeleMainStartDate: this.$route.query.curSeleMainStartDate,//三级页面传来的开始时间
                curSeleMainEndDate: this.$route.query.curSeleMainEndDate,//三级页面传来的结束时间
                type: this.$route.query.type,//三级页面传来的结束时间
                keyWord:"",
                total: 0,
                page: 1,
                limit: 10,
                pageCount: 0, // 页数
                columns: [
                    {
                        title: "姓名",
                        key: "display_name",
                        align: "center",
                        render: (h, params) => {
                            return h("div", [
                                h(
                                    "a",
                                    {
                                        attrs: {
                                            title: "点击进入教师布置作业详情页面",
                                            //让超链接执行一个js函数，而不是跳转到一个地址
                                            href: "javascript:void(0);"
                                        },
                                        style: {
                                            color: "bule",
                                            fontSize: "12px"
                                        },
                                        on: {
                                            click: () => {
                                                this.goAssignHwDetails(params.row, params.index);
                                            }
                                        }
                                    },
                                    params.row.display_name
                                )
                            ]);
                        }
                    },
                    {
                        title: "布置次数",
                        key: "freQuency",
                        align: "center"
                    }
                ],
                assHomeworkTea: [],
            };
        },
        components: {
            dateSelect
        },
        methods: {
            //翻页
            handleCurrentChange (val) {
                this.page = val;
                this.getTeachersList();
            },
            //查询
            handleSearch () {
                this.total = 0;
                this.page = 1;
                this.getTeachersList();
            },
            /**
             * 获取布置作业教师数据
             */
            async getTeachersList () {
                let _this = this;
                let params = {
                    schoolId: _this.schoolId,
                    startDate: _this.selfStartDate,
                    endDate: _this.selfEndDate,
                    keyWord: _this.keyWord,
                    page: _this.page,
                    limit: _this.limit
                };
                await findTeachersList(params)
                    .then(function (data) {
                        _this.assHomeworkTea = data.rows;
                        _this.total = data.total_rows;
                        _this.pageCount = Math.ceil(data.total_rows / _this.limit);
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 返回上一页
             */
            gotoBack () {
                this.$router.push({
                    name: "boardMain",
                    query: {
                        schoolId: this.schoolId,
                        schoolName: this.schoolName,
                        startDate: this.type===1?this.curSeleMainStartDate:this.parentalStartDate,
                        endDate: this.type===1?this.curSeleMainEndDate:this.parentalEndDate,
                    }
                });
            },
            // 点击教师名称进入教师作业布置详情页面
            goAssignHwDetails (row, index) {
                this.$router.push({
                    name: "homeworkDetails",
                    query: {
                        schoolId: this.schoolId,
                        schoolName: this.schoolName,
                        selfStartDate: this.selfStartDate,
                        selfEndDate: this.selfEndDate,
                        parentalStartDate: this.parentalStartDate,
                        parentalEndDate: this.parentalEndDate,
                        page: this.page,
                        limit: this.limit,
                        teaId: row.teaid,
                        routerResource: 1
                    }
                });
            },
            /**
             * 更新开始时间结束时间
             */
            updateDateTime (startDate, endDate) {
                this.page=1;
                this.selfStartDate = startDate;
                this.selfEndDate = endDate;
                this.getTeachersList();
            }
        },
        mounted () {
            this.getTeachersList();
            //修改公共属性学校名称
            this.$store.commit("SET_TOPHEADERNAME", this.schoolName);
            //记住页面选择的开始和结束时间
            this.$refs.dateSelect.setDate(this.parentalStartDate, this.parentalEndDate);
        }
    };
</script>
<style lang="scss" scoped>
    @import "../../../style/home";
    @import "../../../style/dataDetails";
</style>
<style lang="scss">
    .new-data-details {
        .ivu-input-group {
            width: 300px;
            float: right;
        }

        .ivu-card-body {
            padding: 16px;
        }

        .ivu-input-group-append .ivu-btn, .ivu-input-group-prepend .ivu-btn {
            color: #fff;
            background: #57a3f3;
        }

        .ivu-input-group .ivu-input {
            font-size: 14px;
        }

        .ivu-btn-icon-only {
            border-radius: 0 4px 4px 0;
        }
        .time-slot .ivu-col-span-lg-4 {
            display: block;
            width: 355px;
        }
        .ivu-row {
            margin-top: 0 !important;
        }
        .ivu-input-icon-clear {
            margin-right: 45px;
        }

        .ivu-table {
            font-size: 14px;
        }

        .ivu-tabs-nav {
            font-size: 14px;
        }
        .ivu-table-overflowX {
            overflow-x: hidden;
        }
    }
</style>

